
<div class="modal fade show" role="dialog" tabindex="-1" style="display: block;">
    <div class="modal-dialog" role="document" style="min-width: 75vw;">
        <div class="modal-content">
         
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <div>
                                <div class="d-flex justify-content-start table_title">Import From CSV</div>
                            </div>
                        </h5>
                       
                        <button style="background-color: transparent; border: none;color: #9295a4;"
                            (click)="closePopup()"><i class="fa fa-times" aria-hidden="true"></i></button>
                    </div>
              
                    <div class="modal-body">

                        <div>
                          <div class="form-group row mgb-5">
                            <div class="col-md-12 pull-left fleetftsub fw-600 text-center text-dark">
                              Download
                              <a href="assets/import_templates/Edge-ImportTemplate-FloorMaps.csv" download="Edge-ImportTemplate-FloorMaps.csv">
                               Edge-Import-FloorMaps.csv
                              </a>
                            </div>
                          </div>
                          <div class="row justify-content-around">
                            
                          <div class="custom-file mgb-10 fs-12 w-35">
                            <input type="file" class="custom-file-input cursor-pointer" id="excelfile" (change)="getExcelFile($event)"
                              accept=".csv" name="file-input">
                            <label class="custom-file-label text-truncate" id="importFile" for="excelfile"> {{ selectedFileName || 'Choose file' }}</label>
                          </div>
                          <p class="error-msg text-danger mb-0">{{error}}</p>

                        </div>
                        <div style="overflow-x: auto;" class="mt-4">
                          <table class="table-sm table-bordered">
                            <tbody>
                          <tr *ngFor="let row of data">
                                <td *ngFor="let val of row">
                                    {{val}}
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                        </div>
                      </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" style="margin-right: 20px;"
                        (click)="closePopup()">Close</button>
                    <button type="button" class="btn btn-primary" [disabled]="!selectedFileName" style="margin-right: 20px;"
                        (click)="importFloorsData()">Upload</button>
                    
                    </div>
            </div>
        </div>
    </div>
